import { useState, useEffect } from 'react';
import { TextInput } from '../components/FormField';
import { SkillSelector } from '../components/SkillSelector';
import { fetchSkills } from '../api';
import { PREDEFINED_SKILLS } from '@hts/shared';
import type { FormData } from '../types';

interface Props {
  data: FormData;
  onChange: (updates: Partial<FormData>) => void;
  errors?: Record<string, string>;
}

export function SkillsStep({ data, onChange, errors = {} }: Props) {
  const [skills, setSkills] = useState<string[]>([...PREDEFINED_SKILLS]);

  useEffect(() => {
    fetchSkills()
      .then(setSkills)
      .catch(() => {
        // Fallback to predefined skills on error
      });
  }, []);

  return (
    <div>
      <div className="step-header">
        <h2>Skills & Coverage</h2>
        <p>Tell us what type of work your company does and how far you are willing to travel for jobs. Select all that apply.</p>
      </div>

      <div className="form-group">
        <label>
          What services does your company provide? <span className="required">*</span>
        </label>
        <p className="field-hint">Click on each service your company can perform. You can select more than one.</p>
        <SkillSelector selected={data.skills} onChange={(skills) => onChange({ skills })} skills={skills} />
        {errors.skills && <p className="error-text">{errors.skills}</p>}
      </div>

      <div className="form-row">
        <TextInput
          label="How far will you travel for a job? (miles)"
          required
          type="number"
          min={1}
          max={5000}
          value={data.serviceRadiusMi.toString()}
          hint="Enter the maximum distance in miles from your office that you are willing to travel to a job site"
          placeholder="Example: 50"
          onChange={(e) => onChange({ serviceRadiusMi: parseInt(e.target.value, 10) || 50 })}
        />
        <div className="form-group">
          <label>Do you work nationwide?</label>
          <p className="field-hint">Check this if your company works across the entire country</p>
          <label className="agreement-label" style={{ marginTop: 8 }}>
            <input
              type="checkbox"
              checked={data.isNationalBroker}
              onChange={(e) => onChange({ isNationalBroker: e.target.checked })}
            />
            Yes, we operate nationwide
          </label>
        </div>
      </div>
    </div>
  );
}
